module.exports = __webpack_public_path__ + "img/bus-partner-img5.f59a4827.png";